import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../container/context";
import { formatDateTime } from "../../../helpers/helpers";
import serverHost from "../../../services/serverHost";
import peij from "../../../services/peij";
import Form from "../../../components/form";
import ijws from "../../../services/ijws";
import { DisabledByDefault } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function Geral({ unidadeId, unidade, comboNivel, history }) {
  const { notification, confirm } = useContext(AppContext);
  const [editando, setEditando] = useState(false);
  const [dadosDuplicar, setDadosDuplicar] = useState({
    numero: 0,
    titulo: "",
    nivelId: 0,
    descricao: "",
  });

  useEffect(() => {
    const atualizarDados = { ...dadosDuplicar };
    atualizarDados["nivelId"] = unidade.nivelId;
    setDadosDuplicar(atualizarDados);
  }, []);

  const formulario = (unidade) => ({
    numero: {
      label: "Número",
      type: "number",
      value: unidade.numero,
      required: true,
      space: 4,
    },
    titulo: {
      label: "Título",
      type: "text",
      value: unidade.titulo,
      required: true,
      space: 8,
    },
    descricao: {
      label: "Descricao",
      type: "textarea",
      value: unidade.descricao,
      required: true,
      space: 12,
    },
    disponibilizacao: {
      label: "Disponível a partir de",
      type: "date",
      value: unidade.disponibilizacao
        ? formatDateTime(unidade.disponibilizacao.split(" ")[0], "Y-M-D")
        : undefined,
      space: 3,
    },

    nivelId: {
      label: "Nível",
      type: "select",
      value: unidade.nivelId,
      array: {
        data: comboNivel,
        value: "id",
        desc: "nome",
      },
      emptyItem: true,
      emptyItemText: "(Selecione)",
      emptyItemValue: 0,
      space: 3,
      required: true,
    },

    capa: {
      label: "Capa",
      type: "file",
      space: 3,
    },

    previaCapa: {
      type: "component",
      visible: unidade.capa !== "" && unidadeId > 0,
      value: (
        <img
          src={`${serverHost()}/${unidade.capa}`}
          alt="capa"
          className="media-object"
          width="100"
          height="100"
        />
      ),
      space: 3,
    },
    ativo: {
      label: "Ativa",
      type: "check",
      value: unidade.ativo ? unidade.ativo : true,
      space: 12,
    },
  });

  const salvar = (formulario) => {
    const data = new FormData();

    data.append("numero", formulario.numero);
    data.append("titulo", formulario.titulo);
    data.append("descricao", formulario.descricao);
    data.append("ativo", formulario.ativo);
    data.append("nivelId", formulario.nivelId);
    data.append("disponibilizacao", formulario.disponibilizacao);

    if (formulario.capa && formulario.capa[0]) {
      data.append("capa", formulario.capa[0]);
      data.append("extensaoCapa", formulario.capa[0].name.split(".")[1]);
    } else {
      if (unidade.extensaoCapa)
        data.append("extensaoCapa", unidade.extensaoCapa);
    }

    if (unidadeId > 0) {
      data.append("id", unidadeId);
      ijws
        .post("admin/unidades/editar", data)
        .then((res) => {
          notification("success", "Dados salvos!");
          return history.goBack();
        })
        .catch((err) => {
          const { data } = err;

          if (data.includes(1)) return notification("error", "Título inválido");
          if (data.includes(2)) return notification("error", "Número inválido");
          if (data.includes(3)) return notification("error", "Nível inválido");
        });
    } else {
      ijws
        .post("admin/unidades/inserir", data)
        .then((res) => {
          notification("success", "Dados salvos!");
          return history.goBack();
        })
        .catch((err) => {
          const { data } = err;

          if (data.includes(1)) return notification("error", "Título inválido");
          if (data.includes(2)) return notification("error", "Número inválido");
          if (data.includes(3)) return notification("error", "Nível inválido");
        });
    }
  };

  const excluir = () => {
    confirm({
      title: "Deseja realmente excluir a unidade?",
      label: "Esta ação não poderá ser desfeita.",
      onConfirm: () => {
        peij
          .post("unidades/excluir", { id: unidadeId })
          .then((res) => {
            if (res.codes.includes(200)) {
              notification("warning", "Unidade removida.");
              return history.goBack();
            }
            if (res.codes.includes(600)) {
              notification(
                "error",
                "A unidade está presente em um ou mais níveis. Não é possível remover."
              );
              return;
            }
          })
          .catch((err) => {
            notification(
              "error",
              "Não foi possível excluir a unidade. Não é possível excluir unidades que já estejam em uso ou que contenham aulas cadastradas."
            );
          });
      },
    });
  };

  const duplicar = () => {
    confirm({
      title: "Deseja realmente duplicar a unidade?",
      label: "",
      onConfirm: () => {
        peij
          .post("unidades/duplicar", unidade)
          .then((res) => {
            if (res.codes.includes(200)) {
              notification("success", "Unidade duplicada com sucesso!");
              return history.goBack();
            }
            notification("error", "Não foi possível duplicar a unidade.");
          })
          .catch((err) => {
            notification("error", "Erro ao duplicar a unidade");
          });
      },
    });
  };

  const form = {
    title: unidadeId > 0 ? "Editar unidade" : "Cadastrar unidade",
    form: formulario(unidade),
    history,
    close: {},
    submit: {
      action: salvar,
      label: "Salvar",
    },
    customActions:
      unidadeId > 0
        ? [
            // {
            //   warning: true,
            //   label: "Excluir",
            //   action: excluir,
            // },
            {
              label: "Duplicar",
              action: () => setEditando(true),
            },
          ]
        : undefined,
  };

  //   Título: "Unidade a duplicar"
  // Campos:
  // - Número (space 2, apenas leitura)
  // - Título (space 6, apenas leitura)
  // - Nível (space 4, apenas leitura)
  // - Descrição (space 12, apenas leitura)
  // (preencher com valores da unidade que está sendo editada)
  // Botão fechar com a legenda "Cancelar duplicação", retornando à visão anterior

  const fDuplicar = {
    title: "Unidade a duplicar",
    form: {
      numero: {
        label: "Número",
        type: "text",
        value: unidade.numero,
        readOnly: true,
        space: 2,
      },
      titulo: {
        label: "Título",
        type: "text",
        value: unidade.titulo,
        readOnly: true,
        space: 6,
      },
      nivelId: {
        label: "Nível",
        type: "select",
        value: unidade.nivelId,
        array: {
          data: comboNivel,
          value: "id",
          desc: "nome",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
        emptyItemValue: 0,
        space: 4,
        disabled: true,
      },
      descricao: {
        label: "Descricao",
        type: "textarea",
        value: unidade.descricao,
        readOnly: true,
        space: 12,
      },
    },
    close: { label: "Cancelar duplicação", action: () => setEditando(false) },
  };

  const salvarDuplicado = () => {
    const dadosEnviar = dadosDuplicar;
    dadosEnviar.unidadeId = unidadeId;
    console.log("🚀 ~ salvarDuplicado ~ dadosEnviar:", dadosEnviar);
    confirm({
      title: "Deseja realmente duplicar a unidade?",
      label: "",
      onConfirm: () => {
        ijws
          .post("admin/unidades/duplicar", dadosEnviar)
          .then((res) => {
            notification("success", "Unidade duplicada com sucesso!");
            return history.goBack();
          })
          .catch((err) => {
            const { data } = err;

            if (data.includes(1))
              return notification("error", "Título inválido");
            if (data.includes(2))
              return notification("error", "Número inválido");
            if (data.includes(3))
              return notification("error", "Nível inválido");
          });
      },
    });
  };

  const salvarDados = (campo, valor) => {
    const atualizarDados = { ...dadosDuplicar };
    atualizarDados[campo] = valor;
    setDadosDuplicar(atualizarDados);
  };

  const fNovaUnidade = {
    title: "Nova unidade",
    form: {
      numero: {
        label: "Número",
        type: "number",
        value: dadosDuplicar.numero,
        required: true,
        space: 2,
      },
      titulo: {
        label: "Título",
        type: "text",
        value: dadosDuplicar.titulo,
        required: true,
        space: 6,
      },
      nivelId: {
        label: "Nível",
        type: "select",
        value: dadosDuplicar.nivelId,
        // value: unidade.nivelId,
        array: {
          data: comboNivel,
          value: "id",
          desc: "nome",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
        emptyItemValue: 0,
        space: 4,
      },
      descricao: {
        label: "Descricao",
        type: "textarea",
        value: dadosDuplicar.descricao,
        required: true,
        space: 12,
      },
      component: {
        type: "component",
        value: (
          <div>
            <h4>
              A estrutura de aulas da unidade será criada de acordo com a
              estrutura da unidade utilizada como base para a duplicação. Após à
              criação, as referências de vídeos e atividades deverão ser
              preenchidas de acordo com o conteúdo da nova unidade.
            </h4>
          </div>
        ),
        space: 12,
      },
      button: {
        type: "component",
        value: (
          <Button
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            onClick={salvarDuplicado}
          >
            Finalizar duplicação
          </Button>
        ),
        space: 12,
      },
    },
    autoSave: salvarDados,
    // submit: { label: "Finalizar duplicação", action: salvarDuplicado },
  };

  return (
    <div>
      {!editando && <Form formData={form} />}
      {editando && (
        <div>
          <Form formData={fDuplicar} />
          <Form formData={fNovaUnidade} />
          {/* <Form formData={form} /> */}
        </div>
      )}
    </div>
  );
}
